<template>
  <div class="container_box">
    <Tabs v-model="tabName" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in tabList" :label="item.name" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="tabName === 'link'">
            <FormItem :label="$t('key1002962')" prop="employeeIds">
              <Select v-model="pageParams.employeeIds" filterable multiple>
                <Option v-for="item in createdBysList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003231')">
              <Date-picker
                type="daterange"
                class="wid100P"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                format="yyyy-MM-dd"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :options="dateOptions"
                :value="statisticalTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="tabName === 'link'">
            <FormItem :label="$t('key1003117')" prop="linkName">
              <Input :placeholder="$t('key1003232')" v-model.trim="pageParams.linkName"></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="tabName === 'label'">
            <FormItem :label="$t('key1003225')" prop="labelType">
              <Select v-model="pageParams.labelType" filterable :placeholder="$t('key1003233')">
                <Option v-for="item in tokerLabelTypeList" :key="item.labelType" :value="item.labelType">{{ item.labelValue }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="tabName === 'label'">
            <FormItem :label="$t('key1003208')" prop="labelValue">
              <Input :placeholder="$t('key1003234')" v-model.trim="pageParams.labelValue"></Input>
            </FormItem>
          </Col>

          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" v-if="getPermission('ymsToker_insert')" class="mr15"
        @click="$refs['createLink'].createLinkModal = true">{{ $t('key1003128') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--创建链接弹窗-->
    <createLinkModal ref="createLink" :createdBysList="createdBysList" @updateData="pageParamsStatus = true"></createLinkModal>
    <!--链接详情抽屉-->
    <linkDetailsDrawer ref="linkDetails" @updateData="pageParamsStatus = true"></linkDetailsDrawer>
    <!--标签详情抽屉-->
    <labelDetailsDrawer ref="labelDetails" :tokerLabelTypeList="tokerLabelTypeList"></labelDetailsDrawer>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import createLinkModal from "@/views/yms/components/customerManage/createLinkModal.vue";
import linkDetailsDrawer from "@/views/yms/components/customerManage/linkDetailsDrawer.vue";
import labelDetailsDrawer from "@/views/yms/components/customerManage/labelDetailsDrawer.vue";
import {commonCopyContent, getAllUsersInfo, getUserNameByUserId, setLinkPath} from "@/utils/common";

export default {
  name: "tuokeLink",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        startCreatedTime: null, // 统计开始时间
        endCreatedTime: null, // 统计结束时间
        employeeIds: [],
        linkName: '', // 链接名称
        labelType: null, // 标签类型
        labelValue: '', // 标签名称
        source: 'YMS',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableData: [],
      columns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003227'),
          key: 'linkName',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let tokerId = params.row.tokerId;
            let timer = [v.pageParams.startCreatedTime, v.pageParams.endCreatedTime];
            return h('Alink', {
              props: {
                linkName: params.row.linkName,
                styles: {
                  justifyContent: 'flex-start'
                }
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['linkDetails'].initLinkDetailsData('look', tokerId, timer);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003218'),
          key: 'labelValue',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let tokerLabelId = params.row.tokerLabelId;
            let timer = [v.pageParams.startCreatedTime, v.pageParams.endCreatedTime];
            return h('Alink', {
              props: {
                linkName: params.row.labelValue,
                styles: {
                  justifyContent: 'flex-start'
                }
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['labelDetails'].initlabelDetailsData(tokerLabelId, timer);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003228'),
          key: 'labelType',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let text = '';
            let labelType = params.row.labelType;
            v.tokerLabelTypeList.map((item) => {
              if (item.labelType === labelType) {
                text = item.labelValue;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003114'),
          key: 'numberOfClicks',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let numberOfClicks = params.row.numberOfClicks || 0;
            let text = Number(numberOfClicks) > 0 ? numberOfClicks.toLocaleString() : 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003115'),
          key: 'numberOfRegistrants',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003111'),
          key: 'registrationConversionRate',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let registrationConversionRate = params.row.registrationConversionRate;
            let text = registrationConversionRate ? registrationConversionRate + '%' : 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: 'remark',
          width: 300,
          align: 'left',
          render(h, params) {
            let remark = params.row.remark;
            return v.checkContentOverflow(h, remark, 300, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 180,
          align: 'left',
          render: (h, params) => {
            let linkUrl = params.row.linkUrl;
            let timer = [v.pageParams.startCreatedTime, v.pageParams.endCreatedTime];
            let tokerLabelId = params.row.tokerLabelId;
            let text = v.tabName === 'link' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003229') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401');
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: text,
                    show: true,
                    clickFn: () => {
                      if (v.tabName === 'link') {
                        let qRCodeAddress = params.row.qRCodeAddress;
                        if (qRCodeAddress) {
                          let url = setLinkPath(qRCodeAddress);
                          if (url) {
                            window.open(url, '_blank');
                          }
                        }
                      } else {
                        v.$refs['labelDetails'].initlabelDetailsData(tokerLabelId, timer);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003230'),
                    show: v.tabName === 'link',
                    clickFn: () => {
                      commonCopyContent(linkUrl, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tabName: 'link', // link 链接数据   label 标签数据
      tabList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003125'), value: 'link'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003226'), value: 'label'},
      ],
      statisticalTime: [],
      createdBysList: [],
      tokerLabelTypeList: [],
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.createdBysList = [];
      (async () => {
        await this.defaultDateRange();
        await this.getTokerLabelTypeData();
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
          if (data) {
            for (let key in data) {
              this.createdBysList.push({
                userId: data[key].userId,
                userName: data[key].userName
              });
            }
          }
        });
        await this.search();
      })();
    },
    // 设置默认时间
    defaultDateRange() {
      const today = new Date();
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay() + 1); // 设置为本周一，注意星期天为0，所以要加1
      this.pageParams.startCreatedTime = this.$uDate.getUniversalTime(new Date(startOfWeek).getTime());
      this.pageParams.endCreatedTime = this.$uDate.getUniversalTime(new Date(today).getTime());
      this.statisticalTime = [startOfWeek, today];
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.resetDate();
      v.defaultDateRange();
      v.pageParams.labelValue = '';
      v.pageParams.linkName = '';
      v.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.optionBtnWidth = [];
      v.handleColumns();
      if (v.tabName === 'link') {
        if (v.getPermission('ymsToker_query')) {
          v.tableLoading = true;
          let {labelType, labelValue, ...obj} = v.pageParams;
          v.axios.post(api.post_ymsToker_query, obj).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              if (data) {
                v.tableData = data.list || [];
                v.total = data.total;
                v.$nextTick(() => {
                  v.tableLoading = false;
                });
              }
            } else {
              v.tableLoading = false;
            }
          });
        } else {
          v.gotoError();
        }
      } else {
        if (v.getPermission('ymsTokerLabel_query')) {
          v.tableLoading = true;
          let {employeeIds, linkName, ...obj} = v.pageParams;
          obj.source = 'YMS';
          v.axios.post(api.post_ymsTokerLabel_query, obj).then(response => {
            v.tableLoading = false;
            if (response.data.code === 0) {
              let data = response.data.datas;
              if (data) {
                v.tableData = data.list || [];
                v.total = data.total;
              }
            }
          });
        } else {
          v.gotoError();
        }
      }
    },
    // 获取统计时间
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.startCreatedTime = null;
          v.pageParams.endCreatedTime = null;
        } else {
          v.registrationTime = value;
          v.pageParams.startCreatedTime = v.$uDate.getUniversalTime(new Date(value[0]).getTime());
          v.pageParams.endCreatedTime = v.$uDate.getUniversalTime(new Date(value[1]).getTime());
        }
      }
    },
    // 重置统计时间
    resetDate() {
      this.pageParams.startCreatedTime = null;
      this.pageParams.endCreatedTime = null;
    },
    // 处理列表Columns字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let hideKeyList = [];
      if (v.tabName === 'link') {
        hideKeyList = ['labelValue', 'labelType'];
      } else {
        hideKeyList = ['linkName', 'remark', 'createdBy'];
      }
      v.tableColumns = v.columns.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
      v.$forceUpdate();
    },
    // 获取拓客标签类型
    getTokerLabelTypeData() {
      let v = this;
      v.tokerLabelTypeList = [];
      v.axios.get(api.get_ymsTokerLabel_type + 'YMS').then(response => {
        if (response.data.code === 0) {
          v.tokerLabelTypeList = response.data.datas || [];
        }
      });
    },
    // 切换tab
    changeTab() {
      this.$refs['linkDetails'].linkDetailsDrawer = false;
      this.$refs['labelDetails'].labelDetailsDrawer = false;
      this.$nextTick(() => {
        this.pageParams.pageNum = 1;
        this.pageParamsStatus = true;
      });
      this.$forceUpdate();
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    createLinkModal,
    linkDetailsDrawer,
    labelDetailsDrawer
  }
};
</script>

<style lang="less" scoped>

</style>
